import { FocusEventHandler, KeyboardEventHandler, useState } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { GroupBase, Props as ReactSelectProps } from 'react-select';
import CreatableSelect from 'react-select/creatable';

import { CustomStyles, CustomTheme } from './styles';

type Props<
  Option,
  FieldValue = Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = ReactSelectProps<Option, IsMulti, Group> &
  FieldRenderProps<FieldValue, HTMLElement, Option[]> & { labelText: string };

// this component is derived from the React-Select creatable docs: https://react-select.com/creatable
export default function TableFilterReactSelectCreatable({
  input,
  labelText,
  ...rest
}: Props<string, string[], true>) {
  // inputValue is the search text
  const [inputValue, setInputValue] = useState('');

  const { value, onChange, onBlur, ...otherInput } = input;

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        onChange([...value, inputValue]);
        setInputValue('');
        event.preventDefault();
    }
  };
  const handleBlur: FocusEventHandler<HTMLElement> = (event) => {
    if (!inputValue) return;
    onChange([...value, inputValue]);
    setInputValue('');
    onBlur(event);
  };

  return (
    <div className="relative w-full">
      <label
        htmlFor={input.name}
        className="absolute -top-2 left-2 z-10 inline-block bg-white px-1 text-xs font-medium text-gray-500"
      >
        {labelText || input.name}
      </label>
      <CreatableSelect
        theme={CustomTheme}
        styles={CustomStyles}
        components={{
          DropdownIndicator: null,
        }}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue) => onChange(newValue)}
        onBlur={handleBlur}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder="Type something and press enter..."
        value={value}
        getOptionLabel={(option: string) => option}
        getOptionValue={(option: string) => option}
        inputId={input.name}
        {...otherInput}
        {...rest}
      />
    </div>
  );
}
